/**
 * Product page
 *
 * @package Dev
 */

/* global btyMainSlideOptions */

'use strict';

// Gallery slide layout.
const btyGroupGalleryInstances = {};
function btyProductGallery( doc = document ) {
	let gallery      = doc.querySelector( '.main-product[data-id="layout-4"] .gallery-media, .main-product[data-id="layout-5"] .gallery-media, .main-product[data-id="layout-6"] .gallery-media, .main-product[data-id="layout-8"] .gallery-media' ),
		mainSelector = gallery ? gallery.querySelectorAll( '.product-main-slide' ) : false;

	if ( ! mainSelector.length || 'undefined' === typeof( Swiper ) ) {
		return;
	}

	mainSelector.forEach(
		function( el, index ) {
			let groupImage = el.querySelector( '.group-image' ),
				groupId    = groupImage && groupImage.hasAttribute( 'data-color' ) ? groupImage.getAttribute( 'data-color' ) : index;

			// Destroy swiper on desktop.
			if ( window.matchMedia( '(min-width: 992px)' ).matches ) {
				if ( 'object' === typeof( btyGroupGalleryInstances[groupId] ) ) {
					btyGroupGalleryInstances[groupId].destroy();
				}

				return;
			}

			if ( el.classList.contains( 'swiper-initialized' ) ) {
				return;
			}

			// Options.
			let btyMainSlideOptions = {
				slidesPerView: 1,
				spaceBetween: 20,
				autoHeight: true,
				speed: 800,
				navigation: {
					nextEl: el.querySelector( '.swiper-button-next' ),
					prevEl: el.querySelector( '.swiper-button-prev' )
				},
				pagination: {
					el: el.querySelector( '.swiper-pagination' ),
					type: 'custom',
					renderCustom: function( swiper, current, total ) {
						return current + '/' + total;
					}
				}
			}

			// Init.
			btyGroupGalleryInstances[groupId] = new Swiper( el, btyMainSlideOptions );

			// Autoplay video.
			btyGroupGalleryInstances[groupId].on(
				'slideChange',
				function( swp ) {
					btyMediaAction();

					let nthChild      = swp.realIndex + 1,
						mediaTemplate = swp.el.querySelector( '.main-item:nth-child(' + nthChild + ')' );
					if ( mediaTemplate ) {
						setTimeout(
							function() {
								btyLoadMedia( mediaTemplate, 'play' );
							}
						);
					}
				}
			);

			document.documentElement.addEventListener(
				'product-variant-updated',
				function( e ) {
					btyGroupGalleryInstances[groupId].slideTo( e.detail.indexSlide, 800 );
				}
			);
		}
	);
}

// Gallery thumbnail vertical.
const btyGroupGalleryThumbnailVerticalInstances = {};
function btyGalleryThumbnailVertical( doc = document ) {
	let gallery      = doc.querySelector( '.main-product[data-id="layout-1"], .main-product[data-id="layout-2"]' ),
		mainSelector = gallery ? gallery.querySelectorAll( '.product-main-slide' ) : false;

	if ( ! mainSelector.length || 'undefined' === typeof( Swiper ) ) {
		return;
	}

	mainSelector.forEach(
		function( el, index ) {
			let groupImage = el.querySelector( '.group-image' ),
				groupId    = groupImage && groupImage.hasAttribute( 'data-color' ) ? groupImage.getAttribute( 'data-color' ) : index;

			let swiper_thumbs = new Swiper(
				el.nextElementSibling,
				{
					direction: 'horizontal',
					spaceBetween: 16,
					slidesPerView: 3,
					freeMode: false,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
					watchOverflow: true,
					breakpoints: {
						480: {
							direction: 'horizontal',
							slidesPerView: 4
						},
						992: {
							direction: 'horizontal',
							slidesPerView: 4
						}
					}
				}
			);

			let swiper_main = new Swiper(
				el,
				{
					direction: 'horizontal',
					spaceBetween: 20,
					slidesPerView: 1,
					thumbs: {
						swiper: swiper_thumbs
					}
				}
			);

			// Init.
			btyGroupGalleryThumbnailVerticalInstances[groupId] = swiper_main;

			document.documentElement.addEventListener(
				'product-variant-updated',
				function( e ) {
					btyGroupGalleryThumbnailVerticalInstances[groupId].slideTo( e.detail.indexSlide, 800 );
				}
			);
		}
	);
}

// Gallery thumbnail horizontal.
const btyGroupGalleryThumbnailHorizontalInstances = {};
function btyGalleryThumbnailHorizontal( doc = document ) {
	let gallery      = doc.querySelector( '.main-product[data-id="layout-3"], .main-product[data-id="layout-9"]' ),
		mainSelector = gallery ? gallery.querySelectorAll( '.product-main-slide' ) : false;

	if ( ! mainSelector.length || 'undefined' === typeof( Swiper ) ) {
		return;
	}

	mainSelector.forEach(
		function( el, index ) {
			let groupImage = el.querySelector( '.group-image' ),
				groupId    = groupImage && groupImage.hasAttribute( 'data-color' ) ? groupImage.getAttribute( 'data-color' ) : index;

			let swiper_thumbs = new Swiper(
				el.nextElementSibling,
				{
					direction: 'horizontal',
					spaceBetween: 16,
					slidesPerView: 3,
					freeMode: false,
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
					watchOverflow: true,
					breakpoints: {
						480: {
							slidesPerView: 4
						},
						992: {
							slidesPerView: 'auto'
						}
					}
				}
			);

			let swiper_main = new Swiper(
				el,
				{
					spaceBetween: 20,
					slidesPerView: 1,
					thumbs: {
						swiper: swiper_thumbs
					}
				}
			);

			// Init.
			btyGroupGalleryThumbnailHorizontalInstances[groupId] = swiper_main;

			document.documentElement.addEventListener(
				'product-variant-updated',
				function( e ) {
					btyGroupGalleryThumbnailHorizontalInstances[groupId].slideTo( e.detail.indexSlide, 800 );
				}
			);
		}
	);
}

// Gallery slider pagination.
const btyGroupGallerySliderPaginationInstances = {};
function btyGallerySliderPagination( doc = document ) {
	let gallery      = doc.querySelector( '.main-product[data-id="layout-7"]' ),
		mainSelector = gallery ? gallery.querySelectorAll( '.product-main-slide' ) : false;

	if ( ! mainSelector.length || 'undefined' === typeof( Swiper ) ) {
		return;
	}

	mainSelector.forEach(
		function( el, index ) {
			let groupImage = el.querySelector( '.group-image' ),
				groupId    = groupImage && groupImage.hasAttribute( 'data-color' ) ? groupImage.getAttribute( 'data-color' ) : index;

			let swiper_main = new Swiper(
				el,
				{
					slidesPerView: 1,
					pagination: {
						el: el.querySelector( '.swiper-pagination' ),
						clickable: true,
					},
					breakpoints: {
						992: {
							slidesPerView: 3
						}
					}
				}
			);

			// Init.
			btyGroupGallerySliderPaginationInstances[groupId] = swiper_main;

			document.documentElement.addEventListener(
				'product-variant-updated',
				function( e ) {
					btyGroupGallerySliderPaginationInstances[groupId].slideTo( e.detail.indexSlide, 800 );
				}
			);
		}
	);
}

// Hover zoom image for gallery.
function btyGalleryZoom( doc = document ) {
	let selectors = doc.querySelectorAll( '.media-preview-wrap.hover-zoom' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( item ) {
			item.onmousemove = function( e ) {
				let x          = e.offsetX / item.offsetWidth * 100,
					y          = e.offsetY / item.offsetHeight * 100,
					imgFullSrc = item.getAttribute( 'data-zoom' ),
					newImage   = new Image();

				if ( ! imgFullSrc ) {
					return;
				}

				item.classList.add( 'zooming' );

				newImage.crossOrigin = 'anonymous';

				let productImg = item.getAttribute( 'data-key' ) || false;

				// Set background image only first time.
				if ( ! item.style.backgroundImage ) {
					if ( sessionStorage.getItem( productImg ) ) {
						item.style.backgroundImage = 'url(' + sessionStorage.getItem( productImg ) + ')';
					} else {
						item.classList.add( 'loading' );

						newImage.onload = function() {
							let imageSrc = btyGetImageSrc( newImage );

							if ( productImg ) {
								sessionStorage.setItem( productImg, imageSrc );
							}

							item.style.backgroundImage = 'url(' + imageSrc + ')';
							item.classList.remove( 'loading' );
						}

						newImage.src = imgFullSrc;

						newImage.onerror = function() {
							item.classList.remove( 'loading' );
							console.log( 'Error! Loading Image.' );
						}
					}
				}

				// Set background position when hover.
				item.style.backgroundPosition = x + '% ' + y + '%';

				return;
			}

			// Remove BG properties when mouse leave.
			item.onmouseleave = function() {
				item.classList.remove( 'zooming' );
				item.style.backgroundImage    = '';
				item.style.backgroundPosition = '';

				return;
			}
		}
	);
}

// Photoswipe handle.
function btyPhotoswipeHandle( doc = document ) {
	// parse slide data (url, title, dimension ...) from DOM elements (children of gallerySelector).
	let parseThumbnailElements = function( el ) {
		let thumbElements = el.querySelectorAll( '.media-preview-wrap' ),
			items         = [],
			wrapEl, dimension, item;

		if ( ! thumbElements.length ) {
			return;
		}

		for ( let i = 0, ij = thumbElements.length; i < ij; i++ ) {
			wrapEl = thumbElements[ i ];

			// include only element nodes.
			if ( 'BUTTON' !== wrapEl.tagName ) {
				continue;
			}

			dimension = wrapEl.getAttribute( 'data-dimension' );
			if ( ! dimension ) {
				continue;
			}

			dimension = dimension.split( 'x' );

			// create slide object.
			item = {
				src: wrapEl.getAttribute( 'data-zoom' ),
				w: parseInt( dimension[0], 10 ),
				h: parseInt( dimension[1], 10 ),
				position: Number( wrapEl.getAttribute( 'data-pos' ) )
			};

			if ( wrapEl.children.length > 0 ) {
				// <img> thumbnail element, retrieving thumbnail url.
				item.msrc = wrapEl.children[0].getAttribute( 'src' );
			}

			item.el = wrapEl; // save link to element for getThumbBoundsFn.
			items.push( item );
		}

		return items;
	};

	// find nearest parent element.
	let closest = function closest( el, fn ) {
		return el && ( fn( el ) ? el : closest( el.parentNode, fn ) );
	};

	// triggers when user clicks on thumbnail.
	let onThumbnailsClick = function( e ) {
		e = e || window.event;
		e.preventDefault ? e.preventDefault() : e.returnValue = false;

		let eTarget = e.target || e.srcElement;

		if ( eTarget.classList.contains( 'media-360-button' ) ) {
			return;
		}

		// find root element of slide.
		let clickedListItem = closest(
			eTarget,
			function( el ) {
				return ( el.tagName && 'BUTTON' === el.tagName );
			}
		);

		if ( ! clickedListItem ) {
			return;
		}

		// find index of clicked item by looping through all child nodes
		// alternatively, you may define index via data- attribute.
		let clickedGallery = clickedListItem.parentNode.parentNode,
			childNodes     = clickedGallery.childNodes,
			nodeIndex      = 0,
			index;

		for ( let i = 0, j = childNodes.length; i < j; i++ ) {
			if ( childNodes[ i ].nodeType !== 1 ) {
				continue;
			}

			if ( ! childNodes[ i ].querySelector( '[data-dimension]' ) ) {
				continue;
			}

			if ( childNodes[ i ] === clickedListItem.parentNode ) {
				index = nodeIndex;
				break;
			}
			nodeIndex++;
		}

		if ( index >= 0 ) {
			// open PhotoSwipe if valid index found.
			openPhotoSwipe( index, clickedGallery );
		}

		return false;
	};

	// parse picture index and gallery index from URL (#&pid=1&gid=2).
	let photoswipeParseHash = function() {
		let hash   = window.location.hash.substring( 1 ),
			params = {};

		if ( hash.length < 5 ) {
			return params;
		}

		let vars = hash.split( '&' );
		for ( let i = 0, ij = vars.length; i < ij; i++ ) {
			if ( ! vars[ i ] ) {
				continue;
			}
			let pair = vars[ i ].split( '=' );
			if ( pair.length < 2 ) {
				continue;
			}
			params[ pair[0] ] = pair[1];
		}

		if ( params.gid ) {
			params.gid = parseInt( params.gid, 10 );
		}

		return params;
	};

	// open photoswipe.
	let openPhotoSwipe = function( index, galleryElement, disableAnimation, fromURL ) {
		let pswpElement = doc.querySelector( '.pswp' ),
			gallery,
			options,
			items;

		items = parseThumbnailElements( galleryElement );

		// define options (if needed).
		options = {
			// define gallery index (for URL).
			galleryUID: galleryElement.getAttribute( 'data-pswp-uid' ),
			getThumbBoundsFn: function( index ) {
				// See Options -> getThumbBoundsFn section of documentation for more info.
				let thumbnail   = items[ index ].el.querySelector( 'img' ), // find thumbnail.
					pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
					rect        = thumbnail.getBoundingClientRect();

				return {
					x: rect.left,
					y: rect.top + pageYScroll,
					w: rect.width
				};
			}
		};

		// PhotoSwipe opened from URL.
		if ( fromURL ) {
			if ( options.galleryPIDs ) {
				// parse real index when custom PIDs are used
				// http://photoswipe.com/documentation/faq.html#custom-pid-in-url.
				for ( let j = 0, ji = items.length; j < ji; j++ ) {
					if ( items[ j ].pid == index ) {
						options.index = j;
						break;
					}
				}
			} else {
				// in URL indexes start from 1.
				options.index = parseInt( index, 10 ) - 1;
			}
		} else {
			options.index = parseInt( index, 10 );
		}

		// exit if index not found.
		if ( isNaN( options.index ) ) {
			return;
		}

		if ( disableAnimation ) {
			options.showAnimationDuration = 0;
		}

		// Pass data to PhotoSwipe and initialize it.
		gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options );
		gallery.init();

		// Update current slide for Swiper.
		gallery.listen(
			'afterChange',
			function( e ) {
				if ( 'object' === typeof( window.btyMainSlider ) ) {
					let pos = gallery.items[ gallery.getCurrentIndex() ].position - 1;
					window.btyMainSlider.slideTo( pos, 0 );
				}
			}
		);
	};

	// loop through all gallery elements and bind events.
	let galleryElements = doc.querySelectorAll( '.product-main-slide' );
	if ( galleryElements.length ) {
		for ( let i = 0, l = galleryElements.length; i < l; i++ ) {
			galleryElements[ i ].setAttribute( 'data-pswp-uid', i + 1 );
			galleryElements[ i ].onclick = onThumbnailsClick;
		};

		// Parse URL and open gallery if it contains #&pid=3&gid=1.
		let hashData = photoswipeParseHash();
		if ( hashData.pid && hashData.gid ) {
			openPhotoSwipe( hashData.pid, galleryElements[ hashData.gid - 1 ], true, true );
		};
	}
}

// Detect model exit.
function btyModelExit() {
	document.addEventListener(
		'click',
		function( e ) {
			let el   = e.target,
				node = document.querySelector( '.product-main-slide' ) ? '.product-main-slide' : '.single-media';

			if ( ! el.closest( node ) ) {
				btyMediaAction();
			}
		}
	);
}

// Product model html structure.
customElements.define(
	'product-model',
	class ProductModel extends HTMLElement {
	constructor() {
		super();

		const poster = this.querySelector( '[id^="deferred-poster-"]' );
		if ( ! poster ) {
			return;
		}

		poster.addEventListener( 'click', this.loadContent.bind( this ) );
	}

	loadContent() {
		if ( ! this.getAttribute( 'loaded' ) ) {
			const content = document.createElement( 'div' );

			content.appendChild( this.querySelector( 'template' ).content.firstElementChild.cloneNode( true ) );

			this.setAttribute( 'loaded', true );

			const deferredElement = this.appendChild( content.querySelector( 'model-viewer' ) );
		}

		Shopify.loadFeatures(
			[
				{
					name: 'model-viewer-ui',
					version: '1.0',
					onLoad: this.setupModelViewerUI.bind( this )
				}
			]
		);
	}

	setupModelViewerUI( errors ) {
		if ( errors ) {
			return;
		}

		this.modelViewerUI = new Shopify.ModelViewerUI( this.querySelector( 'model-viewer' ) );
	}
	}
);

// Product model setup.
window.ProductModel = {
	loadShopifyXR() {
		Shopify.loadFeatures(
			[
				{
					name: 'shopify-xr',
					version: '1.0',
					onLoad: this.setupShopifyXR.bind( this )
				}
			]
		);
	},
	setupShopifyXR( errors ) {
		if ( errors ) {
			return;
		}

		if ( ! window.ShopifyXR ) {
			document.addEventListener( 'shopify_xr_initialized', () => this.setupShopifyXR() );

			return;
		}

		let modelConfig = document.getElementById( 'product-model-config' );
		if ( ! modelConfig ) {
			return;
		}

		window.ShopifyXR.addModels( JSON.parse( modelConfig.textContent ) );
		window.ShopifyXR.setupXRElements();

		modelConfig.remove();
	}
};

// Toggle modal.
function btyToggleModal( doc = document ) {
	let selectors = doc.querySelectorAll( '.modal-toggle-button' ),
		modal     = doc.querySelector( '.product-modal' ),
		close     = modal ? modal.querySelector( '.media-modal-toggle' ) : false;
	if ( ! selectors.length || ! close ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			el.onclick = function() {
				modal.classList.add( 'is-open' );

				let item = modal.querySelector( '[data-media-id="' + el.parentNode.getAttribute( 'data-media-id' ) + '"]' );
				if ( ! item ) {
					return;
				}

				document.documentElement.classList.add( 'overflow-hidden' );
				item.classList.add( 'active' );
			}
		}
	);

	close.onclick = function() {
		let modalActive = modal.querySelector( '.product-model.active' );
		if ( modalActive ) {
			modalActive.classList.remove( 'active' );
		}

		modal.classList.remove( 'is-open' );
		document.documentElement.classList.remove( 'overflow-hidden' );
	}
}

// Sticky add to cart.
function btyStickyAddToCart( doc = document ) {
	let selector = doc.querySelector( '.sticky-add-to-cart' );
	if ( ! selector ) {
		return;
	}

	let image        = selector.querySelector( '.sticky-product-image' ),
		price        = selector.querySelector( '.product-price' ),
		form         = selector.querySelector( '[data-type="add-to-cart-form"]' ),
		formSummary  = selector.closest( '.shopify-section' ).querySelector( '.summary-item .product-buy' ),
		productId    = selector.querySelector( '[name="id"]' ),
		button       = selector.querySelector( '[name="add"]' ),
		qtyInput     = selector.querySelector( '.quantity-input' ),
		variants     = selector.closest( '.shopify-section' ).querySelector( '[data-product-variants]' ),
		quantity     = selector.closest( '.shopify-section' ).querySelector( '[data-inventory-quantity]' ),
		field        = selector.querySelectorAll( '.field-value' ),
		variant_pick = {};

	if ( ! variants || ! quantity ) {
		return;
	}

	variants = btyJsonParse( variants.textContent );
	quantity = btyJsonParse( quantity.textContent );

	if ( field.length ) {
		field.forEach(
			function( el ) {
				variant_pick[ el.name ] = el.value;

				el.onchange = function() {
					variant_pick[ el.name ] = el.value;

					let selected = btySelectedVariant( variant_pick, variants, window.btyMainSlider );
					if ( selected ) {
						// Update product variant ID.
						if ( productId ) {
							productId.value = selected.id;
						}

						// Update image on Featured product.
						if ( image && selected.featured_image ) {
							btyImageLoad( image, selected.featured_image.src, selected.featured_media.id, image.parentNode );
						}

						// Update price.
						if ( price ) {
							price.innerHTML = btyPriceHtml( selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement );
						}

						// Set max quantity.
						if ( qtyInput ) {
							let max = quantity.filter(
								function ( e ) {
									return e.id === selected.id;
								}
							);

							if ( max.length ) {
								let qty = max[0].qty;

								if ( qty > 0 ) {
									if ( Number( qtyInput.value ) > qty ) {
										qtyInput.value = qty;
									}

									qtyInput.setAttribute( 'max', qty );
								} else {
									qtyInput.removeAttribute( 'max' );
								}
							} else {
								qtyInput.removeAttribute( 'max' );
							}
						}
					}

					// Update add to cart button text.
					if ( button ) {
						if ( selected ) {
							if ( selected.available ) {
								button.innerHTML = btyStrings.product.add_to_cart;
								button.classList.remove( 'disabled' );
							} else {
								button.innerHTML = btyStrings.product.out_of_stock;
								button.classList.add( 'disabled' );
							}
						} else {
							button.classList.add( 'disabled' );
							button.innerHTML = btyStrings.product.unavailable;
						}
					}
				}
			}
		);
	}

	// Scroll to show.
	let summaryAddToCart = doc.querySelector( '.summary-item.add-to-cart' );
	if ( ! summaryAddToCart ) {
		return;
	}

	// Scroll to add to cart.
	const scrollToAddToCart = function() {
		button.addEventListener(
			'click',
			function() {
				if ( window.matchMedia( '(min-width: 768px)' ).matches || ! button.classList.contains( 'add-product-variants' ) || ! formSummary ) {
					return;
				}

				formSummary.scrollIntoView( { behavior: 'smooth', block: 'end', inline: 'end' } );
			}
		);
	}
	scrollToAddToCart();

	const observerSummaryAddToCart = new IntersectionObserver(
		function( entries ) {
			window.addEventListener(
				'resize',
				function() {
					scrollToAddToCart();
				}
			);

			if ( entries[0].intersectionRatio <= 0 ) {
				selector.classList.add( 'active' );
			} else {
				selector.classList.remove( 'active' );
			}
		}
	);

	observerSummaryAddToCart.observe( summaryAddToCart );
}

// Complementary products summary.
function btyComplementaryProducts( doc = document ) {
	let selector = doc.querySelector( '.product-summary .complementary-products-container' );
	if ( ! selector ) {
		return;
	}

	let url = selector.getAttribute( 'data-url' );

	if ( selector.innerHTML.trim() || ! url ) {
		return;
	}

	fetch( url )
		.then(
			function( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function( res ) {
				selector.innerHTML = btyGetSectionHtml( res, '.product-summary .complementary-products-container' );

				btyQuickView( selector );
				btyCarousel( selector );
				btyAnimationImageLoad( selector );
				btyAddToCart( selector );
				btyAccordionHandle( selector );

				btyQuantityButton( selector );
				btyComplementaryUpdateProduct( selector );
				btyComplementaryTotalPrice( selector );
				btyComplementaryAddMultiProductToCart( selector );
				btyComplementaryBuyNow( selector );
			}
		).catch(
			function( err ) {
				console.log( err );
			}
		);
}

// Complementary products sidebar.
function btyComplementaryProductsSidebar( doc = document ) {
	let selector = doc.querySelector( '.product-sidebar .complementary-products-container' );
	if ( ! selector ) {
		return;
	}

	let url = selector.getAttribute( 'data-url' );

	if ( selector.innerHTML.trim() || ! url ) {
		return;
	}

	fetch( url )
		.then(
			function( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function( res ) {
				selector.innerHTML = btyGetSectionHtml( res, '.product-sidebar .complementary-products-container' );

				btyCarousel( selector );
				btyAnimationImageLoad( selector );
			}
		).catch(
			function( err ) {
				console.log( err );
			}
		);
}

// Complementary update product.
function btyComplementaryUpdateProduct( doc = document ) {
	let selector = doc.querySelectorAll( '.product-summary .complementary-card' );

	if ( ! selector.length ) {
		return;
	}

	selector.forEach(
		function( sl ) {
			let image          = sl.querySelector( '.card-media img' ),
				price          = sl.querySelector( '.product-price' ),
				form           = sl.querySelector( '[data-type="add-to-cart-form"]' ),
				formSummary    = sl.closest( '.shopify-section' ).querySelector( '.summary-item .product-buy' ),
				productId      = sl.querySelector( '[name="id"]' ),
				button         = sl.querySelector( '[name="add"]' ),
				qtyInput       = sl.querySelector( '.quantity-input' ),
				variants       = sl.querySelector( '[data-product-variants]' ),
				quantity       = sl.querySelector( '[data-inventory-quantity]' ),
				field          = sl.querySelectorAll( '.field-value' ),
				payment_button = sl.querySelector( '.shopify-payment-button' ),
				variant_pick   = {},
				total_price    = sl.closest( '.complementary-products' ).querySelector( '.total-complementary .total-price' )

			if ( ! variants || ! quantity ) {
				return;
			}

			variants = btyJsonParse( variants.textContent );
			quantity = btyJsonParse( quantity.textContent );

			if ( field.length ) {
				field.forEach(
					function( el ) {
						variant_pick[ el.name ] = el.value;

						el.onchange = function() {
							variant_pick[ el.name ] = el.value;

							let selected = btySelectedVariant( variant_pick, variants, window.btyMainSlider );
							if ( selected ) {
								// Update product variant ID.
								if ( productId ) {
									productId.value = selected.id;

									// Dispatch 'change' event.
									productId.dispatchEvent( new Event( 'change' ) );
								}

								// Update image on Featured product.
								if ( image && selected.featured_image ) {
									image.removeAttribute( 'srcset' );
									btyImageLoad( image, selected.featured_image.src, selected.featured_media.id, image.parentNode );
								}

								// Update price.
								if ( price ) {
									price.innerHTML = btyPriceHtml( selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement );
								}

								// Set max quantity.
								if ( qtyInput ) {
									let max = quantity.filter(
										function ( e ) {
											return e.id === selected.id;
										}
									);

									if ( max.length ) {
										let qty = max[0].qty;

										if ( qty > 0 ) {
											if ( Number( qtyInput.value ) > qty ) {
												qtyInput.value = qty;
											}

											qtyInput.setAttribute( 'max', qty );
										} else {
											qtyInput.removeAttribute( 'max' );
										}
									} else {
										qtyInput.removeAttribute( 'max' );
									}
								}

								// Enable and disable quantity.
								if ( qtyInput ) {
									if ( selected.available ) {
										qtyInput.closest( '.product-quantity' ).classList.remove( 'disabled' );
									} else {
										qtyInput.closest( '.product-quantity' ).classList.add( 'disabled' );
									}
								}

								// Enable and disable payment button.
								if ( payment_button ) {
									if ( selected.available ) {
										payment_button.classList.remove( 'disabled' );
									} else {
										payment_button.classList.add( 'disabled' );
									}
								}

								// Update price in total price.
								if ( price ) {
									let card_item_id           = el.closest( '.card-content[data-product-id]' ),
										price_input_id         = el.closest( '.complementary-products' ).querySelector( '.total-complementary .total-price [data-product-id="' + card_item_id.getAttribute( 'data-product-id' ) + '"]' ),
										compare_price_input_id = price_input_id.nextSibling,
										quantity_input_id      = compare_price_input_id.nextSibling;

									if ( selected.available ) {
										price_input_id.value = selected.price;

										if ( selected.compare_at_price ) {
											compare_price_input_id.value = selected.compare_at_price;
										} else {
											compare_price_input_id.value = selected.price;
										}

										quantity_input_id.value = qtyInput.value;
									} else {
										price_input_id.removeAttribute( 'value' );
										compare_price_input_id.removeAttribute( 'value' );
										quantity_input_id.removeAttribute( 'value' );
									}

									// Function total price.
									btyComplementaryTotalPrice();
								}
							}

							// Update add to cart button text.
							if ( button ) {
								if ( selected ) {
									if ( selected.available ) {
										button.innerHTML = btyStrings.product.add_to_cart;
										button.classList.remove( 'disabled' );
									} else {
										button.innerHTML = btyStrings.product.out_of_stock;
										button.classList.add( 'disabled' );
									}
								} else {
									button.classList.add( 'disabled' );
									button.innerHTML = btyStrings.product.unavailable;
								}
							}
						}
					}
				);
			}
		}
	);
}

// Ajax update total price.
function btyComplementaryTotalPrice( doc = document ) {
	let selectors = doc.querySelectorAll( '.complementary-products .total-price' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function(sl) {
			let items = sl.querySelectorAll( '[data-product-id]' );

			if ( ! items.length ) {
				return;
			}

			let	items_count            = items.length,
				total_price            = 0,
				total_compare_at_price = 0;

			for ( let i = 0; i < items_count; i++ ) {
				total_price            = total_price + Number( sl.querySelector( '[name="items[' + i + '][price]"]' ).value ) * Number( sl.querySelector( '[name="items[' + i + '][quantity]"]' ).value );
				total_compare_at_price = total_compare_at_price + Number( sl.querySelector( '[name="items[' + i + '][compare_at_price]"]' ).value ) * Number( sl.querySelector( '[name="items[' + i + '][quantity]"]' ).value );
			}

			sl.querySelector( '.product-price' ).innerHTML = btyPriceHtml( total_price, total_compare_at_price );
		}
	);
}

// Ajax add all set to cart.
function btyComplementaryAddMultiProductToCart( doc = document ) {
	let selectors = doc.querySelectorAll( '.complementary-add-multiple-products' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let items_id = el.closest( '.complementary-products' ).querySelectorAll( '.complementary-card [name="id"]' );
			if ( ! items_id.length ) {
				return;
			}

			items_id.forEach(
				function( item, index ) {
					item.addEventListener(
						'change',
						function() {
							let currentId = el.querySelector( '[data-index="' + index + '"]' );
							if ( currentId ) {
								currentId.value = item.value;
							}
						}
					);
				}
			);

			let items_quantity = el.closest( '.complementary-products' ).querySelectorAll( '.complementary-card [name="quantity"]' );
			if ( ! items_quantity.length ) {
				return;
			}

			items_quantity.forEach(
				function( item, index ) {
					item.addEventListener(
						'change',
						function() {
							let currentQuantity = el.querySelector( '[name="items[' + index + '][quantity]"]' );
							if ( currentQuantity ) {
								currentQuantity.value = item.value;
							}

							// Update quantity in total price.
							let currentQuantityPriceTotal = el.parentNode.querySelector( '.total-price [name="items[' + index + '][quantity]"]' );
							if ( currentQuantityPriceTotal ) {
								currentQuantityPriceTotal.value = item.value;
							}

							// Function total price.
							btyComplementaryTotalPrice();
						}
					);
				}
			);
		}
	);
}

// Complementary buy now button.
function btyComplementaryBuyNow( doc = document ) {
	let buttons = doc.querySelectorAll( '.complementary-products .buy-now-button' );
	if ( ! buttons.length ) {
		return;
	}

	// Register dom html need an update when the response available.
	let modules = [
		{
			node: '.side-cart-inner', // DOM html selector.
			section: 'side-cart', // Section name.
			selector: '.side-cart-inner' // Ajax response selector.
	},
		{
			section: 'cart-count'
	}
	];

	buttons.forEach(
		function( button ) {
			button.onclick = function( e ) {
				// Return user click Tab button then Enter.
				if ( button.classList.contains( 'disabled' ) ) {
					e.preventDefault();

					return;
				}

				if ( 'A' === button.tagName.toUpperCase() ) {
					return;
				}

				e.preventDefault();

				if ( button.classList.contains( 'add-product-variants' ) && window.matchMedia( '(max-width: 767px)' ).matches ) {
					return;
				}

				button.classList.add( 'loading' );

				let form     = button.closest( '[data-type="add-to-cart-form"]' ),
					formData = new FormData( form ),
					warning  = form.parentNode.querySelector( '.product-warning' ),
					config   = btyFetchConfig( 'javascript' );

				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				formData.append( 'sections', modules.map( (s) => s.section ) );
				config.body = formData;

				// Fetch data.
				fetch( btyGlobals.cart_add_url, config )
					.then(
						function( r ) {
							return r.json();
						}
					).then(
						function( res ) {
							if ( warning ) {
								warning.innerHTML = '';
							}

							if ( res.status && warning ) {
								warning.innerHTML = btyGlobals.svg_warning + res.description;

								return;
							}

							// Update html.
							btyUpdateHtml( res.sections, modules );

							// Update cart items count.
							btyCartItemCount( btyGetSectionHtml( res.sections['cart-count'], '.shopify-section' ) );

							window.location.href = '/cart/checkout';
						}
					).catch(
						function( e ) {
							console.error( e );
						}
					).finally(
						function() {
							// Re-init quantity.
							btyQuantityButton();

							// Re-init update quantity button.
							btyUpdateProductQuantity();

							// Remove loading animation.
							button.classList.remove( 'loading' );
						}
					);
			}
		}
	);
}

// Update frequently bought together products.
function btyFbtUpdateProducts( doc = document ) {
	let selector = doc.querySelectorAll( '.product-frequently-bought-together .content-item[data-product-id]' );

	if ( ! selector.length ) {
		return;
	}

	selector.forEach(
		function( el ) {
			let image                  = el.closest( '.list-products' ).querySelector( '.media-item[data-product-id="' + el.getAttribute( 'data-product-id' ) + '"] img' ),
				price                  = el.querySelector( '.product-price' ),
				productId              = el.querySelector( '[name="id"]' ),
				variants               = el.querySelector( '[data-product-variants]' ),
				quantity               = el.querySelector( '[data-inventory-quantity]' ),
				field                  = el.querySelectorAll( '.field-value' ),
				content_checkbox_input = el.querySelector( 'input[type="checkbox"]' ),
				media_checkbox_input   = el.closest( '.product-frequently-bought-together' ).querySelector( '.checkbox-media input[type="checkbox"]' ),
				variant_pick           = {},
				content_item_input     = el.querySelector( 'input[type="checkbox"]' ),
				media_item_id          = el.closest( '.product-frequently-bought-together' ).querySelector( '.checkbox-media .media-item[data-product-id="' + el.getAttribute( 'data-product-id' ) + '"]' ),
				media_item_input       = media_item_id.querySelector( 'input[type="checkbox"]' );

			// Update checked input.
			if ( content_checkbox_input || media_checkbox_input ) {
				media_item_input.checked   = true;
				content_item_input.checked = true;

				let price_input_id         = el.closest( '.product-frequently-bought-together' ).querySelector( '.total-fbt .total-price [data-product-id="' + el.getAttribute( 'data-product-id' ) + '"]' ),
					compare_price_input_id = price_input_id.nextSibling,
					quantity_input_id      = compare_price_input_id.nextSibling,
					add_cart_id            = el.closest( '.product-frequently-bought-together' ).querySelector( '.total-fbt .fbt-add-multiple-products [data-product-id="' + el.getAttribute( 'data-product-id' ) + '"]' ),
					add_cart_quantity      = el.closest( '.product-frequently-bought-together' ).querySelector( '.total-fbt .fbt-add-multiple-products [data-qty][data-product-id="' + el.getAttribute( 'data-product-id' ) + '"]' );

				media_item_input.onchange = function() {
					if ( media_item_input.checked == true ) {
						content_item_input.checked = true;

						price_input_id.removeAttribute( 'disabled', 'disabled' );
						compare_price_input_id.removeAttribute( 'disabled', 'disabled' );
						quantity_input_id.removeAttribute( 'disabled', 'disabled' );
						add_cart_id.removeAttribute( 'disabled', 'disabled' );
						add_cart_quantity.removeAttribute( 'disabled', 'disabled' );
					} else {
						content_item_input.checked = false;

						price_input_id.setAttribute( 'disabled', 'disabled' );
						compare_price_input_id.setAttribute( 'disabled', 'disabled' );
						quantity_input_id.setAttribute( 'disabled', 'disabled' );
						add_cart_id.setAttribute( 'disabled', 'disabled' );
						add_cart_quantity.setAttribute( 'disabled', 'disabled' );
					}

					// Update total price.
					btyFbtTotalPrice();

					// Disable total add to cart button when all product not selected.
					let cart_add_item          = el.closest( '.product-frequently-bought-together' ).querySelectorAll( '.total-fbt .fbt-add-multiple-products [data-index]' ),
						cart_add_item_disabled = el.closest( '.product-frequently-bought-together' ).querySelectorAll( '.total-fbt .fbt-add-multiple-products [data-index][disabled]' );

					if ( ! cart_add_item.length ) {
						return;
					}

					if ( cart_add_item_disabled.length == cart_add_item.length ) {
						el.closest( '.product-frequently-bought-together' ).querySelector( '.fbt-add-multiple-products .add-to-cart-button' ).classList.add( 'disabled' );
					} else {
						el.closest( '.product-frequently-bought-together' ).querySelector( '.fbt-add-multiple-products .add-to-cart-button' ).classList.remove( 'disabled' );
					}
				}

				content_item_input.onchange = function() {
					if ( content_item_input.checked == true ) {
						media_item_input.checked = true;

						price_input_id.removeAttribute( 'disabled', 'disabled' );
						compare_price_input_id.removeAttribute( 'disabled', 'disabled' );
						quantity_input_id.removeAttribute( 'disabled', 'disabled' );
						add_cart_id.removeAttribute( 'disabled', 'disabled' );
						add_cart_quantity.removeAttribute( 'disabled', 'disabled' );
					} else {
						media_item_input.checked = false;

						price_input_id.setAttribute( 'disabled', 'disabled' );
						compare_price_input_id.setAttribute( 'disabled', 'disabled' );
						quantity_input_id.setAttribute( 'disabled', 'disabled' );
						add_cart_id.setAttribute( 'disabled', 'disabled' );
						add_cart_quantity.setAttribute( 'disabled', 'disabled' );
					}

					// Update total price.
					btyFbtTotalPrice();

					// Disable total add to cart button when all product not selected.
					let cart_add_item          = el.closest( '.product-frequently-bought-together' ).querySelectorAll( '.total-fbt .fbt-add-multiple-products [data-index]' ),
						cart_add_item_disabled = el.closest( '.product-frequently-bought-together' ).querySelectorAll( '.total-fbt .fbt-add-multiple-products [data-index][disabled]' );

					if ( ! cart_add_item.length ) {
						return;
					}

					if ( cart_add_item_disabled.length == cart_add_item.length ) {
						el.closest( '.product-frequently-bought-together' ).querySelector( '.fbt-add-multiple-products .add-to-cart-button' ).classList.add( 'disabled' );
					} else {
						el.closest( '.product-frequently-bought-together' ).querySelector( '.fbt-add-multiple-products .add-to-cart-button' ).classList.remove( 'disabled' );
					}
				}
			}

			if ( ! variants || ! quantity ) {
				return;
			}

			variants = btyJsonParse( variants.textContent );
			quantity = btyJsonParse( quantity.textContent );

			// Update product when change variants.
			if ( field.length ) {
				field.forEach(
					function( el ) {
						variant_pick[ el.name ] = el.value;

						el.onchange = function() {
							variant_pick[ el.name ] = el.value;

							let selected = btySelectedVariant( variant_pick, variants, window.btyMainSlider );
							if ( selected ) {
								// Update product variant ID.
								if ( productId ) {
									productId.value = selected.id;

									// Dispatch 'change' event.
									productId.dispatchEvent( new Event( 'change' ) );
								}

								// Update image on Featured product.
								if ( image && selected.featured_image ) {
									image.removeAttribute( 'srcset' );
									btyImageLoad( image, selected.featured_image.src, selected.featured_media.id, image.parentNode );
								}

								// Update price.
								if ( price ) {
									price.innerHTML = btyPriceHtml( selected.price, selected.compare_at_price, selected.unit_price, selected.unit_price_measurement );
								}

								// Update enable/disable checkbox.
								if ( content_checkbox_input || media_checkbox_input ) {
									if ( selected.available ) {
										content_checkbox_input.classList.remove( 'disabled' );
										content_checkbox_input.parentNode.querySelector( '.checkmark' ).classList.remove( 'disabled' );
										media_checkbox_input.classList.remove( 'disabled' );
										media_checkbox_input.parentNode.querySelector( '.checkmark' ).classList.remove( 'disabled' );
									} else {
										content_checkbox_input.classList.add( 'disabled' );
										content_checkbox_input.parentNode.querySelector( '.checkmark' ).classList.add( 'disabled' );
										media_checkbox_input.classList.add( 'disabled' );
										media_checkbox_input.parentNode.querySelector( '.checkmark' ).classList.add( 'disabled' );
									}
								}

								// Update price in total price.
								if ( price ) {
									let card_item_id           = el.closest( '.content-item[data-product-id]' ),
										price_input_id         = el.closest( '.product-frequently-bought-together' ).querySelector( '.total-fbt .total-price [data-product-id="' + card_item_id.getAttribute( 'data-product-id' ) + '"]' ),
										compare_price_input_id = price_input_id.nextSibling,
										quantity_input_id      = compare_price_input_id.nextSibling;


									price_input_id.value = selected.price;

									if ( selected.compare_at_price ) {
										compare_price_input_id.value = selected.compare_at_price;
									} else {
										compare_price_input_id.value = selected.price;
									}

									if ( selected.available && content_item_input.checked == true ) {
										price_input_id.removeAttribute( 'disabled', 'disabled' );
										compare_price_input_id.removeAttribute( 'disabled', 'disabled' );
									} else {
										price_input_id.setAttribute( 'disabled', 'disabled' );
										compare_price_input_id.setAttribute( 'disabled', 'disabled' );
									}

									// Update total price.
									btyFbtTotalPrice();
								}
							}
						}
					}
				);
			}
		}
	);
}

// Ajax frequently bought together update total price.
function btyFbtTotalPrice( doc = document ) {
	let selectors = doc.querySelectorAll( '.product-frequently-bought-together .total-price' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function(sl) {
			let items = sl.querySelectorAll( '[data-product-id]' );

			if ( ! items.length ) {
				return;
			}

			let	items_count            = items.length,
				total_price            = 0,
				total_compare_at_price = 0;

			for ( let i = 0; i < items_count; i++ ) {
				if ( sl.querySelector( '[name="items[' + i + '][price]"]:not([disabled])' ) ) {
					total_price            = total_price + Number( sl.querySelector( '[name="items[' + i + '][price]"]' ).value ) * Number( sl.querySelector( '[name="items[' + i + '][quantity]"]' ).value );
					total_compare_at_price = total_compare_at_price + Number( sl.querySelector( '[name="items[' + i + '][compare_at_price]"]' ).value ) * Number( sl.querySelector( '[name="items[' + i + '][quantity]"]' ).value );
				}
			}

			sl.querySelector( '.product-price' ).innerHTML = btyPriceHtml( total_price, total_compare_at_price );
		}
	);
}

// Ajax add all frequently bought together products to cart.
function btyFbtAddMultiProductToCart( doc = document ) {
	let selectors = doc.querySelectorAll( '.fbt-add-multiple-products' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let items_id = el.closest( '.product-frequently-bought-together' ).querySelectorAll( '.content-item [name="id"]' );
			if ( ! items_id.length ) {
				return;
			}

			items_id.forEach(
				function( item, index ) {
					item.addEventListener(
						'change',
						function() {
							let currentId = el.querySelector( '[data-index="' + index + '"]' );
							if ( currentId ) {
								currentId.value = item.value;
							}
						}
					);
				}
			);
		}
	);
}

// Product recommendations.
function btyProductRecommendations( doc = document ) {
	let selector = doc.querySelector( '.product-recommendations' );
	if ( ! selector ) {
		return;
	}

	let url = selector.getAttribute( 'data-url' );

	if ( selector.innerHTML.trim() || ! url ) {
		return;
	}

	fetch( url )
		.then(
			function( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function( res ) {
				selector.innerHTML = btyGetSectionHtml( res, '.product-recommendations' );

				btyAddToCart( selector );
				btyQuickView( selector );
				btySwatch( selector );
				btyAnimationImageLoad( selector );
				btyHoverMediaVideo( selector );
				btyQuickAdd( selector );
				btyQuickAddPopup( selector );
				btyCarousel( selector );
				btyCompare( doc );
				btyShowMoreSwatches( selector );
			}
		).catch(
			function( err ) {
				console.log( err );
			}
		);
}

// Random number customers viewing.
function btyRandomCustomersViewing( doc = document ) {
	let selectors = doc.querySelectorAll( '.product-customers-viewing' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let min       = Number( el.getAttribute( 'data-min-number' ) ),
				max       = Number( el.getAttribute( 'data-max-number' ) ),
				second    = el.getAttribute( 'data-customer-view-time' ) * 1000,
				num_field = el.querySelector( '.number' );

			if ( ! num_field ) {
				return;
			}

			// Set the initial number.
			num_field.innerText = Math.floor( Math.random() * (max - min + 1) ) + min;

			// Change number after every seconds.
			const numberFn = function() {
				num_field.innerText = Math.floor( Math.random() * (max - min + 1) ) + min;
			}

			let init = setInterval( numberFn, second );
		}
	);
}

// Calculate delivery time.
function btyDeliveryTime( doc = document ) {
	let selectors = doc.querySelectorAll( '.product-delivery-time' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let date_element      = el.querySelector( '.delivery-date' ),
				start_date_number = Number( el.getAttribute( 'data-start-date' ) ),
				end_date_number   = Number( el.getAttribute( 'data-end-date' ) ),
				exclude_days      = el.getAttribute( 'data-exclude-days' );

			// Get exclude days array and remove items invalid.
			let array_exclude_days = exclude_days.split( /\s*,\s*/ ),
				array_days_code    = ['MON','TUE','WED','THU','FRI','SAT','SUN'];

			array_exclude_days = array_exclude_days.filter( one => array_days_code.find( two => one == two ) );

			// Convert exclude days array to days number array.
			for ( let i = 0, j = array_exclude_days.length; i < j; i++ ) {
				switch ( array_exclude_days[i] ) {
					case 'SUN':
						array_exclude_days[i] = 0;
						break;
					case 'MON':
						array_exclude_days[i] = 1;
						break;
					case 'TUE':
						array_exclude_days[i] = 2;
						break;
					case 'WED':
						array_exclude_days[i] = 3;
						break;
					case 'THU':
						array_exclude_days[i] = 4;
						break;
					case 'FRI':
						array_exclude_days[i] = 5;
						break;
					case 'SAT':
						array_exclude_days[i] = 6;
				}
			}

			// Calculate start date.
			let start_today = new Date(),
				start_date  = '',
				start_count = 0;

			while ( start_count < start_date_number ) {
				start_date = new Date( start_today.setDate( start_today.getDate() + 1 ) );

				if ( ! array_exclude_days.includes( start_date.getDay() ) ) {
					start_count++;
				}
			}

			// Calculate end date.
			let end_today = new Date(),
				end_date  = '',
				end_count = 0;

			while ( end_count < end_date_number ) {
				end_date = new Date( end_today.setDate( end_today.getDate() + 1 ) );

				if ( ! array_exclude_days.includes( end_date.getDay() ) ) {
					end_count++;
				}
			}

			// Format date.
			const month_names = ['January','February','March','April','May','June','July','August','September','October','November','December'];

			let start_date_date   = start_date.getDate(),
				start_date_month  = start_date.getMonth(),
				format_start_date = start_date_date + ' ' + month_names[start_date_month];

			let end_date_date   = end_date.getDate(),
				end_date_month  = end_date.getMonth(),
				format_end_date = end_date_date + ' ' + month_names[end_date_month];

			// Export result to html.
			date_element.innerHTML = format_start_date + ' - ' + format_end_date;
		}
	);
}

// Discount coupon copy button.
function btyDiscountCouponCopy( doc = document ) {
	let selectors = doc.querySelectorAll( '.product-discount .discount-item' );
	if ( ! selectors.length ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			let button  = el.querySelector( '.copy-button' ),
				message = el.closest( '.product-discount' ).querySelector( '.message' );

			if ( ! button || ! message ) {
				return;
			}

			button.addEventListener(
				'click',
				function() {
					let discount_code = el.getAttribute( 'data-discount-code' );

					message.classList.remove( 'success-message', 'error-message', 'hidden' );

					if ( discount_code ) {
						// Copy discount code to clipboard.
						navigator.clipboard.writeText( discount_code );

						// Show success message.
						message.classList.add( 'success-message' );
						message.textContent = btyStrings.product.discount_success_message;
					} else {
						// Show error message.
						message.classList.add( 'error-message' );
						message.textContent = btyStrings.product.discount_error_message;
					}
				}
			);
		}
	);
}

// Toggle product 360 popup.
function btyToggleThreeSixtyProduct( doc = document ) {
	let selectors = doc.querySelectorAll( '.media-360-button' ),
		modal     = doc.querySelector( '.product-360' ),
		close     = modal ? modal.querySelector( '.media-360-toggle' ) : false;
	if ( ! selectors.length || ! close ) {
		return;
	}

	selectors.forEach(
		function( el ) {
			el.onclick = function() {
				modal.classList.add( 'is-open' );

				document.documentElement.classList.add( 'overflow-hidden' );
			}
		}
	);

	close.onclick = function() {
		modal.classList.remove( 'is-open' );
		document.documentElement.classList.remove( 'overflow-hidden' );
	}
}

// Change src image of list image 360.
function btyThreeSixtyChangeImageSrc( doc = document ) {
	let threesixty_popup = doc.querySelectorAll( '.product-360' );
	if ( ! threesixty_popup.length ) {
		return;
	}

	threesixty_popup.forEach(
		function( el ) {
			let image = el.querySelectorAll( '.data-threesixty-image img' );

			if ( ! image.length ) {
				return;
			}

			image.forEach(
				function( img ) {
					// Handle loading image.
					const imageLoadHandle = function( dataSrc, main ) {
						if ( ! img ) {
							return;
						}

						let newImage = new Image();

						newImage.crossOrigin = 'anonymous';

						// Handle.
						newImage.onload = function() {
							let renderImage = btyGetImageSrc( newImage );

							// Set final image src.
							img.src = renderImage;
							img.removeAttribute( 'srcset' );
						}

						// Set image src for 'newImage.onload' function handle.
						newImage.src = dataSrc;
					}

					// Update product image src.
					let src = img.getAttribute( 'src' ) || '';
					if ( src && src != img.src ) {
						imageLoadHandle( src );
					}
				}
			);
		}
	);
}

function btyPreloadImages( array ) {
	if ( ! btyPreloadImages.list ) {
		btyPreloadImages.list = [];
	}
	var list = btyPreloadImages.list;
	for (var i = 0, j = array.length; i < j; i++) {
		var img = new Image();

		img.onload = function() {
			var index = list.indexOf( this );
			if (index !== -1) {
				// remove image from the array once it's loaded
				// for memory consumption reasons.
				list.splice( index, 1 );
			}
		}

		list.push( img );
		img.src = array[i];
	}
}


// Product 360 actions.
function btyThreeSixtyProduct( doc = document ) {
	let threesixty_popup = doc.querySelectorAll( '.product-360' );
	if ( ! threesixty_popup.length ) {
		return;
	}

	threesixty_popup.forEach(
		function( el ) {
			let wrapper = el.querySelector( '.data-threesixty-image' ),
				image   = wrapper.querySelectorAll( '.data-threesixty-image img' );

			if ( ! wrapper || ! image.length ) {
				return;
			}

			let data_image = [];

			for ( let i = 1, j = image.length; i <= j; i++ ) {
				let img_src = wrapper.querySelector( '.media-preview-wrap[data-pos="' + i + '"] .media-preview' ).getAttribute( 'src' );
				data_image.push( img_src );
			}

			btyPreloadImages( data_image );

			const threesixty = new ThreeSixty(
				el.querySelector( '.threesixty-image' ),
				{
					image: data_image,
					width: 600,
					height: 600,
					speed: 63,
					prev: el.querySelector( '.buttons-control .prev' ),
					next: el.querySelector( '.buttons-control .next' )
				}
			);

			let play_button = el.querySelector( '.buttons-control .play' );

			if ( play_button ) {
				play_button.addEventListener(
					'click',
					function() {
						threesixty.play();
					}
				);
			}

			let stop_button = el.querySelector( '.buttons-control .stop' );

			if ( stop_button ) {
				stop_button.addEventListener(
					'click',
					function() {
						threesixty.stop();
					}
				);
			}
		}
	);
}

document.addEventListener(
	'DOMContentLoaded',
	function() {
		if ( window.ProductModel ) {
			window.ProductModel.loadShopifyXR();
		}

		btyStickyAddToCart();
		btyToggleModal();
		btyProductGallery();
		btyPhotoswipeHandle();
		btyProductRecommendations();
		btyComplementaryProducts();
		btyComplementaryProductsSidebar();
		btyGalleryThumbnailVertical();
		btyGalleryThumbnailHorizontal();
		btyGallerySliderPagination();
		btyComplementaryUpdateProduct();
		btyComplementaryTotalPrice();
		btyComplementaryAddMultiProductToCart();
		btyFbtUpdateProducts();
		btyFbtTotalPrice();
		btyFbtAddMultiProductToCart();
		btyRandomCustomersViewing();
		btyDeliveryTime();
		btyDiscountCouponCopy();
		btyThreeSixtyChangeImageSrc();
		btyToggleThreeSixtyProduct();

		window.addEventListener(
			'resize',
			function() {
				btyProductGallery();
			}
		);

		setTimeout(
			function() {
				btyThreeSixtyProduct();
			},
			2000
		);
	}
);

document.addEventListener(
	'shopify:section:load',
	function( e ) {
		let section = e.target.closest( 'section.shopify-section' );

		setTimeout(
			function() {
				btyComplementaryProducts( section );
				btyComplementaryProductsSidebar( section );
				btyProductRecommendations( section );
				btyStickyAddToCart( section );
				btyGalleryThumbnailVertical( section );
				btyGalleryThumbnailHorizontal( section );
				btyGallerySliderPagination( section );
				btyProductMediaDesktop();
				btyComplementaryUpdateProduct( section );
				btyComplementaryTotalPrice( section );
				btyComplementaryAddMultiProductToCart( section );
				btyFbtUpdateProducts( section );
				btyFbtTotalPrice( section );
				btyFbtAddMultiProductToCart( section );
				btyRandomCustomersViewing( section );
				btyDeliveryTime( section );
				btyDiscountCouponCopy( section );
			}
		);
	}
);

document.addEventListener(
	'shopify:section:select',
	function( e ) {
		let section = e.target;

		btyProductGallery( section );
		btyPhotoswipeHandle( section );

		setTimeout(
			function() {
				btyComplementaryProducts( section );
				btyComplementaryProductsSidebar( section );
				btyProductRecommendations( section );
				btyStickyAddToCart( section );
				btyGalleryThumbnailVertical( section );
				btyGalleryThumbnailHorizontal( section );
				btyGallerySliderPagination( section );
				btyComplementaryUpdateProduct( section );
				btyComplementaryTotalPrice( section );
				btyComplementaryAddMultiProductToCart( section );
				btyFbtUpdateProducts( section );
				btyFbtTotalPrice( section );
				btyFbtAddMultiProductToCart( section );
				btyRandomCustomersViewing( section );
				btyDeliveryTime( section );
				btyDiscountCouponCopy( section );
			}
		);
	}
);

document.addEventListener(
	'shopify:block:select',
	function( e ) {
		let section = e.target.closest( '.shopify-section' );
		if ( ! section ) {
			return;
		}

		btySlider( section, e );
		btyProductGallery( section );
		btyPhotoswipeHandle( section );
		btyStickyAddToCart( section );
		btyComplementaryUpdateProduct( section );
		btyComplementaryTotalPrice( section );
		btyComplementaryAddMultiProductToCart( section );
		btyFbtUpdateProducts( section );
		btyFbtTotalPrice( section );
		btyFbtAddMultiProductToCart( section );
		btyRandomCustomersViewing( section );
		btyDeliveryTime( section );
		btyDiscountCouponCopy( section );
	}
);
